var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPayments = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 7.33335V24C36.6667 25.8334 35.1667 27.3334 33.3333 27.3334H6.66667C5.75 27.3334 5 26.5834 5 25.6667C5 24.75 5.75 24 6.66667 24H33.3333V7.33335C33.3333 6.41669 34.0833 5.66669 35 5.66669C35.9167 5.66669 36.6667 6.41669 36.6667 7.33335ZM5 20.6667C2.23333 20.6667 0 18.4334 0 15.6667V5.66669C0 2.90002 2.23333 0.666687 5 0.666687H25C27.7667 0.666687 30 2.90002 30 5.66669V17.3334C30 19.1667 28.5 20.6667 26.6667 20.6667H5ZM10 10.6667C10 13.4334 12.2333 15.6667 15 15.6667C17.7667 15.6667 20 13.4334 20 10.6667C20 7.90002 17.7667 5.66669 15 5.66669C12.2333 5.66669 10 7.90002 10 10.6667Z",
    fill: "#493AB1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPayments, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/payments.90a4615e.svg";
export { ForwardRef as ReactComponent };